import { Tag } from "antd";
import { isPermissionPresent } from "../../../../../utilities/generalUtility";
import K from "../../../../../utilities/constants";
import { convertIntoDashUSFormat } from "../../../../../utilities/dateUtility";
import { stringSorting } from "../../../../../utilities/tableUtility";
import { tooltipTagRenderer } from "../../../../billingCommissions/submitToBilling/tableColumns";
import { EditIconButton } from "../../../../../common/components/iconButton/editIconButton";
import { DefaultColumnOptions } from "../../../../../hooks/useDataGrid/options";

const actionColumnRenderer = (roles, editRecord) => (params) => (
  <>
    {isPermissionPresent(K.Permissions.EditClass, roles) && (
      <EditIconButton onClick={() => editRecord(params.data.id)} />
    )}
  </>
);

const titleRenderer = (params) => params.data.title ?? "N/A";

const classDateReceivedRenderer = (params) =>
  convertIntoDashUSFormat(params.data.classDateReceived, false);

const classStartDateRenderer = (params) =>
  convertIntoDashUSFormat(params.data.classStartDate, false);

const offerApprovalDateRenderer = (params) =>
  convertIntoDashUSFormat(params.data.offerApprovalDate, false);

const classSizeRenderer = (params) => params.data.classSize ?? 0;

const notesRenderer = (params) => params.data.notes ?? "N/A";

const singleTagRenderer = (params, key, color) =>
  params.data[key]?.name ? (
    <Tag color={color}>{params.data[key]?.name} </Tag>
  ) : (
    "N/A"
  );

const singleTagSearchRenderer = (params, key, color) =>
  params.data[key]?.name ?? "N/A";

const tooltipClassDateReceived = (params) => (
  <div className="client-list-tooltip">
    {convertIntoDashUSFormat(params.data.classDateReceived, false)}
  </div>
);
const tooltipClassStartDate = (params) => (
  <div className="client-list-tooltip">
    {convertIntoDashUSFormat(params.data.classStartDate, false)}
  </div>
);

const tooltipOfferApprovalDate = (params) => (
  <div className="client-list-tooltip">{offerApprovalDateRenderer(params)}</div>
);

const tooltipClassSize = (params) => (
  <div className="client-list-tooltip">{params.data.classSize ?? 0}</div>
);

const tooltipNotesRenderer = (params) => (
  <div className="client-list-tooltip">{params.data.notes ?? "N/A"}</div>
);

export const getColumns = (roles, editRecord) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Class Title",
    field: "title",
    sortable: true,
    tooltipField: "title",
    cellRenderer: titleRenderer,
  },
  {
    headerName: "Class Status",
    field: "classStatus",
    sortable: true,
    tooltipField: "classStatus",
  },
  {
    headerName: "Class Date Received",
    field: "classDateReceived",
    sortable: true,
    tooltipField: "classDateReceived",
    cellRenderer: classDateReceivedRenderer,
    tooltipComponent: tooltipClassDateReceived,
  },
  {
    headerName: "Class Start Date",
    field: "classStartDate",
    sortable: true,
    sort: "asc",
    tooltipField: "classStartDate",
    cellRenderer: classStartDateRenderer,
    tooltipComponent: tooltipClassStartDate,
  },
  {
    headerName: "Offer Approval Date",
    field: "offerApprovalDate",
    sortable: true,
    tooltipField: "offerApprovalDate",
    getQuickFilterText: offerApprovalDateRenderer,
    cellRenderer: offerApprovalDateRenderer,
    tooltipComponent: tooltipOfferApprovalDate,
  },
  {
    headerName: "Regional Director",
    field: "regionalDirector",
    sortable: true,
    tooltipField: "regionalDirector",
    getQuickFilterText: (params) =>
      singleTagSearchRenderer(params, "regionalDirector", "#0070C0"),
    comparator: (a, b, nodeA, nodeB, isDescending) =>
      stringSorting(a, b, "name"),
    cellRenderer: (params) =>
      singleTagRenderer(params, "regionalDirector", "#0070C0"),
    tooltipComponent: (params) => tooltipTagRenderer(params, null),
  },
  {
    headerName: "Human Resource Manager",
    field: "humanResource",
    sortable: true,
    tooltipField: "humanResource",
    getQuickFilterText: (params) =>
      singleTagSearchRenderer(params, "humanResource", "#0070C0"),
    comparator: (a, b, nodeA, nodeB, isDescending) =>
      stringSorting(a, b, "name"),
    cellRenderer: (params) =>
      singleTagRenderer(params, "humanResource", "#0070C0"),
    tooltipComponent: (params) => tooltipTagRenderer(params, null),
  },
  {
    headerName: "Internal Manager",
    field: "internalManager",
    sortable: true,
    tooltipField: "internalManager",
    getQuickFilterText: (params) =>
      singleTagSearchRenderer(params, "internalManager", "#0070C0"),
    comparator: (a, b, nodeA, nodeB, isDescending) =>
      stringSorting(a, b, "name"),
    cellRenderer: (params) =>
      singleTagRenderer(params, "internalManager", "#0070C0"),
    tooltipComponent: (params) => tooltipTagRenderer(params, null),
  },
  {
    headerName: "Current Openings",
    field: "classSize",
    sortable: true,
    tooltipField: "classSize",
    cellRenderer: classSizeRenderer,
    tooltipComponent: tooltipClassSize,
  },
  {
    headerName: "Notes",
    field: "notes",
    sortable: true,
    tooltipField: "notes",
    cellRenderer: notesRenderer,
    tooltipComponent: tooltipNotesRenderer,
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditClass, roles),
    cellRenderer: actionColumnRenderer(roles, editRecord),
  },
];
